import { useAtom } from 'jotai';
import { memo, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Option, Select } from '@/lib/v2/components';

import { atomCreateOrEditIntegrationForm } from '@/modules/IntegrationsModule/atoms/integrations';
import { useStepsOptions } from '@/modules/IntegrationsModule/hooks/CreateOrEditIntegration';
import { ControlFormProps } from '@/modules/IntegrationsModule/types';

interface StepOneProps extends ControlFormProps {
  onNext?: MouseEventHandler<HTMLButtonElement>;
}

export const OPTION_ONE = 'one';
export const OPTION_TWO = 'two';

const StepOne = ({ control, name, rules, onNext }: StepOneProps) => {
  const { t } = useTranslation();
  const [stateForm, setStateForm] = useAtom(atomCreateOrEditIntegrationForm);
  const { optionsStepOne } = useStepsOptions();

  const handleSelectStepOneChange = (option: Option | Option[]) => {
    if (Array.isArray(option)) {
      return;
    }
    setStateForm((prev) => ({
      ...prev,
      stepOne: option,
    }));
  };

  return (
    <div className="flex w-full max-w-[350px] flex-col items-end">
      <Select
        control={control}
        name={name}
        options={optionsStepOne}
        rules={rules}
        value={stateForm.stepOne}
        onChange={handleSelectStepOneChange}
      />
      <Button size="small" onClick={onNext}>
        {t('StepOne.next')}
      </Button>
    </div>
  );
};

export default memo(StepOne);
